var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from '../PreviewElements.module.scss';
import { mockCells, shadows } from '../../mock';
import { fields } from '../../../utils';
import { useActionsColors, useCommonTheme, useCurrentTheme } from '../../../../../../../hooks/useCurrentTheme';
import { useMatrixFilterColor } from '../../../../../../../hooks/useMatrixFilterColor';
import { getCellTextStyleSettings } from '../../../../../../../Viewer/MultiMatrix/utils';
var Cell = function (_a) {
    var type = _a.type, _b = _a.isTwoPlayers, isTwoPlayers = _b === void 0 ? false : _b;
    var getColor = useActionsColors();
    var getFillColor = useMatrixFilterColor();
    var theme = useCurrentTheme();
    var _c = useCommonTheme(), matrix = _c.matrix, isDrawReverseActions = _c.isDrawReverseActions;
    var indent = matrix.indent, rounding = matrix.rounding, useSubstrate = matrix.useSubstrate, fontSize1player = matrix.fontSize1player, shadow = matrix.shadow, fontSize2player = matrix.fontSize2player;
    var settingsWrapper = function (isStrategy, mapper, fontSize) { return getCellTextStyleSettings(isStrategy, true, mapper, fontSize); };
    var mapperType = type === 'actions' || type === 'presets' ? 'strategy' : type;
    var textColor = !isTwoPlayers
        ? theme.matrix.substrate.textcolor1playermatrix
        : theme.matrix.substrate.textcolor2playermatrix;
    var fontSizeType = !isTwoPlayers ? fontSize1player : fontSize2player;
    var textShadowType = shadow;
    var isStrategy = mapperType === 'strategy';
    var customBorderColor = theme.matrix.substrate['border color'];
    var maxVals = {
        range: 0.92,
        ev: 0.0322,
        equity: 0.92,
        eqr: 2.05,
    };
    var minVals = {
        range: 0.15,
        ev: 0.0122,
        equity: 0.12,
        eqr: 0.0,
    };
    var getGradient = function (actions, weight, index) {
        var gradientWidth = 0;
        var gradientWidthArray = [];
        var gradientColors = [];
        var abs = weight ? (index - 2) / 10 : 1;
        var reversed = isDrawReverseActions ? actions.slice().reverse() : actions;
        reversed.forEach(function (action) {
            var color = getColor(action.name, action.rI, action.isAllIn);
            var weightHeight = ((100 * abs) / 100) * 100;
            var weightWidth = action.percent + gradientWidth;
            gradientWidth = weightWidth;
            gradientWidthArray.push("".concat(weightWidth, "% ").concat(weightHeight, "%"));
            gradientColors.push("linear-gradient(to right, ".concat(color, " , ").concat(color, ")"));
        });
        return { gradientColors: gradientColors, gradientWidthArray: gradientWidthArray };
    };
    var getText = function (type, cell) {
        return type === 'ev' ? "+".concat((cell[type] * 100).toFixed(2)) : "".concat((cell[type] * 100).toFixed(), "%");
    };
    var lineHeight = settingsWrapper(isStrategy, 'lineHeight', fontSizeType);
    var lineHeightPercent = '16px';
    // const foreignObjectWidth = '70%'
    // const foreignObjectX = '15%'
    // const foreignObjectY = settingsWrapper(isStrategy, 'substrateY', fontSizeType)
    var borderRadius = rounding ? '5px' : '';
    var background = useSubstrate && !isTwoPlayers ? theme.matrix.substrate.color : '';
    var renderData = isTwoPlayers ? mockCells.slice(0, 6) : mockCells;
    return (_jsx("div", __assign({ className: styles.cellsPreviewWrapper, style: { borderSpacing: indent ? '5px' : 0 } }, { children: renderData.map(function (cell, index) {
            var img = getFillColor({
                field: fields[type],
                played: cell[type],
                fieldMax: maxVals[type],
                fieldMin: minVals[type],
                matrixRange: theme.matrix.range,
                matrixEquity: theme.matrix.equity,
                matrixEv: theme.matrix.ev,
                matrixEqr: theme.matrix.eqr,
                minEquityRealization: minVals[type],
                maxEquityRealization: maxVals[type],
            });
            var _a = getGradient(cell.actions, cell.weight, index), gradientColors = _a.gradientColors, gradientWidthArray = _a.gradientWidthArray;
            var backgroundImage = type === 'actions' || type === 'presets'
                ? gradientColors.join(',')
                : "linear-gradient(to right, ".concat(img, " , ").concat(img, ")");
            var backgroundSize = type === 'actions' || type === 'presets'
                ? gradientWidthArray.join(',')
                : cell.weight
                    ? "100% ".concat(index * 7, "%")
                    : "100% 100%";
            return (_jsx("div", __assign({ style: {
                    backgroundImage: backgroundImage,
                    backgroundSize: backgroundSize,
                    color: textColor,
                    textShadow: shadows[textShadowType],
                    // @ts-ignore
                    '--custom-border-color': "".concat(customBorderColor),
                    borderRadius: borderRadius,
                    // minHeight: indent ? 55 : 60,
                    marginRight: indent ? '5px' : 0,
                    marginBottom: indent ? '5px' : 0,
                    width: indent ? 'calc(33% - 5px)' : '33%',
                    height: indent ? 'calc(25% - 5px)' : '25%',
                } }, { children: _jsxs("span", __assign({ style: { background: background, borderRadius: borderRadius, textAlign: 'center', minWidth: '70%' } }, { children: [_jsx("span", __assign({ style: {
                                fontSize: settingsWrapper(isStrategy, 'fontSize', fontSizeType),
                                lineHeight: lineHeight,
                            } }, { children: cell.name })), type !== 'actions' && type !== 'presets' ? (_jsx("div", __assign({ style: {
                                fontSize: settingsWrapper(false, 'fontSizePercent', fontSizeType),
                                lineHeight: lineHeightPercent,
                                marginTop: 4,
                            } }, { children: getText(type, cell) }))) : null] })) }), cell.name));
        }) })));
};
export default Cell;
